import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { HeroVisual } from './HeroVisual';
export function Hero() {
  return <section id="hero" className="relative pt-32 pb-20 md:pt-48 md:pb-32 overflow-hidden bg-navy" data-id="element-74">
      {/* Background Accents */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-full pointer-events-none" data-id="element-75">
        <div className="absolute top-20 right-10 w-96 h-96 bg-brand-gradient rounded-full blur-3xl opacity-20" data-id="element-76" />
        <div className="absolute bottom-10 left-10 w-72 h-72 bg-white/5 rounded-full blur-3xl opacity-80" data-id="element-77" />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-78">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-79">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-80">
            <h1 className="text-5xl md:text-6xl lg:text-[64px] leading-[1.1] font-bold mb-6 text-white" data-id="element-81">
              Hire Exceptional LATAM Talent Without the{' '}
              <span style={{
              color: '#F35BC8'
            }} data-id="element-82">
                Recruiting Headaches
              </span>
            </h1>

            <p className="text-xl text-slate-200 font-medium mb-4" data-id="element-83">
              Your strategic talent partner connecting global companies with
              exceptional professionals across Latin America.
            </p>

            {/* Mobile-only visual, shown below the subheadline */}
            <div className="md:hidden relative h-[440px] w-full mb-8 mt-2" data-id="element-84">
              <HeroVisual data-id="element-85" />
            </div>

            <p className="text-lg text-slate-300 mb-10 leading-relaxed" data-id="element-86">
              We help companies hire carefully vetted, English-speaking
              professionals across Accounting, Finance, Operations, Customer
              Success, Marketing, Technology, and Administrative
              Support—typically within 2–3 weeks.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-12" data-id="element-87">
              <a href="https://calendly.com/partners-talvoritalents/30min?month=2026-06" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-white bg-brand-gradient rounded-full hover:shadow-glow transition-all hover:-translate-y-0.5" data-id="element-88">
                Book a Free Consultation
              </a>
              <a href="#roles" className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-white bg-white/5 border-2 border-white/20 rounded-full hover:bg-white/10 hover:border-white/40 transition-all" data-id="element-89">
                Explore Roles
              </a>
            </div>

            <div className="flex flex-col sm:flex-row gap-6 text-sm font-medium text-slate-200" data-id="element-90">
              <div className="flex items-center gap-2" data-id="element-91">
                <CheckCircle2 className="text-coral w-5 h-5" data-id="element-92" />
                <span data-id="element-93">Shortlist in 5–10 business days</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-94">
                <CheckCircle2 className="text-coral w-5 h-5" data-id="element-95" />
                <span data-id="element-96">Hire in 2–3 weeks</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-97">
                <CheckCircle2 className="text-coral w-5 h-5" data-id="element-98" />
                <span data-id="element-99">Replacement Guarantee Included</span>
              </div>
            </div>
          </motion.div>

          {/* Right Visual */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative h-[500px] lg:h-[600px] w-full hidden md:block" data-id="element-100">
            <HeroVisual data-id="element-101" />
          </motion.div>
        </div>
      </div>
    </section>;
}